import {
  isAsyncTaskProgressAction,
  isAsyncTaskProposalAction,
} from '../../utils/is-async-task-proposal-action';
import AsyncTaskProgress from './AsyncTaskProgress';
import AsyncTaskProposal from './AsyncTaskProposal';

interface AsyncTaskActionCardProps {
  readonly data: unknown;
  /** Used when the action payload omits `conversationId` (V2 shell path). */
  readonly conversationIdFallback?: string | null;
  /** Only the newest card may drive the chat forward (parity with EmailDraftCard). */
  readonly isLastMessage?: boolean;
  readonly onSendMessage?: (message: string, skill?: string) => void;
  /** Chat-message identity, forwarded to the progress card. */
}

/** Shared V1/V2 mount for `async-task` proposal and progress cards. */
export function AsyncTaskActionCard({
  data,
  conversationIdFallback,
  isLastMessage,
  onSendMessage,
}: AsyncTaskActionCardProps) {
  const fallback = conversationIdFallback || undefined;

  if (isAsyncTaskProposalAction(data)) {
    return (
      <AsyncTaskProposal
        proposalId={data.proposalId}
        name={data.name}
        instructions={data.instructions || ''}
        conversationId={data.conversationId || fallback}
      />
    );
  }

  if (isAsyncTaskProgressAction(data)) {
    return (
      <AsyncTaskProgress
        runId={data.runId}
        name={data.name}
        conversationId={data.conversationId || fallback}
        isLastMessage={isLastMessage}
        onSendMessage={onSendMessage}
      />
    );
  }

  return null;
}
